import React, { FC } from 'react';
import Image from 'next/image';

import { Card } from '../../SocialProof';
import { TypeSocialProofAvatarItemFields } from '@/core/generated-types';

const SocialAvatar = ({
  avatarAsset,
  avatarHandle = '',
  avatarTitle,
}: Partial<TypeSocialProofAvatarItemFields>) => {
  return (
    <div className="flex items-center gap-2 md:py-4">
      {avatarAsset && (
        <Image
          className="max-w-[40px] max-h-[40px] md:max-w-[50px] md:max-h-[50px]"
          src={`https:${avatarAsset.fields.file?.url}`}
          width={50}
          height={50}
          alt={avatarHandle}
        />
      )}
      <div className="flex flex-col justify-center">
        <p className="text-[13px] font-bold leading-5">{avatarTitle}</p>
        <p className="text-[13px] leading-5">{avatarHandle}</p>
      </div>
    </div>
  );
};

const SocialItem: FC<TypeSocialProofAvatarItemFields> = ({
  asset,
  avatarAsset,
  avatarHandle,
  avatarTitle = '',
  breakAfter,
  description,
}) => {
  return (
    <Card classes={breakAfter ? 'break-after-column' : ''}>
      {asset && (
        <Image
          className="rounded-t-lg"
          src={`https:${asset.fields.file?.url}`}
          alt={avatarTitle}
          width={322}
          height={200}
          sizes="(max-width: 768px) 322px, 230px"
          quality={75}
          loading="lazy"
        />
      )}
      <div className="py-2 px-4 md:p-[2vw] ">
        {description && (
          <p className="text-[13px] mb-2 leading-5 md:text-base">
            {description}
          </p>
        )}
        {avatarAsset && (
          <SocialAvatar
            avatarAsset={avatarAsset}
            avatarHandle={avatarHandle}
            avatarTitle={avatarTitle}
          />
        )}
      </div>
    </Card>
  );
};

export default SocialItem;
